module.exports = __webpack_public_path__ + "static/media/Location-blue.8a9bfff9.svg";